import React from "react";
import { GoogleAnalyticsHelper } from "../../utils";
import { Link, PriceInCurrency, LinkButton } from "../../misc";
import { HeroSection } from "../../layout";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./SampleItineraryHeader.scss";

interface SampleItineraryHeaderProps {
  /**
   * Itinerary data object
   */
  itinerary: ISampleItinerarySummary;
}

/**
 * Header component for a sample itinerary.
 *
 * @status development
 */
export const SampleItineraryHeader: React.FC<SampleItineraryHeaderProps> = ({
  itinerary
}) => {
  const regionSlug = itinerary?.locations
    .find(itin => itin.slug === itinerary?.primaryLocation?.slug)?.parent?.slug || "";

  const enquireRouteParams = {
    locationSlug: itinerary?.primaryLocation?.slug,
    itineraryId: itinerary.id,
    campaign: "trip-idea-1",
  };

  return (
    <HeroSection
      heroImage={itinerary.heroImage}
      images={itinerary.days.map(day => day.image)}
      className="wrap-children"
    >
      <div className="columns is-paddingless is-marginless">
        <div className="column is-two-thirds-tablet is-half-desktop is-paddingless">
          <div className="sample-itinerary-header">
            <div className="sample-itinerary-header__name">
              <span className="sample-itinerary-header__label">Trip idea in{` `}
                <Link
                  to={WebRoutes.country(itinerary.primaryLocation.slug, regionSlug)}
                  onClick={() => GoogleAnalyticsHelper.logEvent("Select Country", "Click", "Itinerary page breadcrumb")}
                >
                  {itinerary.primaryLocation.name}
                </Link>
              </span>

              <h1 className="heading--1 is-marginless">{itinerary.name}</h1>

              <div className="sample-itinerary-header__cta is-hidden-tablet">
                <LinkButton
                  buttonClass="primary-button"
                  to={WebRoutes.enquiryForm(enquireRouteParams)}
                >
                  Enquire now
                </LinkButton>
              </div>
            </div>
            <div className="sample-itinerary-header__details">
              <div className="columns is-marginless">
                <div className="column is-two-fifths-tablet">
                  <p className="sample-itinerary-header__label">Cost</p>
                  <p className="heading--4 is-marginless">
                    from{` `}
                    <PriceInCurrency priceInCurrency={itinerary.pricePerPerson} roundUpToNearest={10} />{` `}
                    pp
                  </p>
                  <p className="text--label">(ex international flights)</p>
                </div>
                <div className="column">
                  <p className="sample-itinerary-header__label">Duration</p>
                  <p className="heading--4 is-marginless">
                    {itinerary.days.length} days
                </p>
                </div>
                <div className="column is-hidden-mobile">
                  <LinkButton
                    buttonClass="primary-button"
                    to={WebRoutes.enquiryForm(enquireRouteParams)}
                  >
                    Enquire now
                  </LinkButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </HeroSection>
  )
}
